import Footer from "../Footer"
import GoBackButton from "./GoBackButton"
import { useParams } from "react-router-dom"
import services from "../../data/services"
import OpenPricesButton from "./OpenPricesButton"
import PhoneButton from "./PhoneButton"
import { Fade } from "@mui/material"
import timeout from "../../data/timeout"

const SingleService = ({ language }) => {
  const params = useParams()
  const service = services.find((service) => service.link === params.slug)
  let description
  if (service.description) {
    const textDescription = language
      ? service.description.ua
      : service.description.en
    description = textDescription
  }

  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
  setTimeout(() => {
    scrollUp()
  }, 100)

  return (
    <Fade timeout={timeout} in>
      <div className="pt-24 flex flex-col justify-between min-h-screen ">
        <GoBackButton />
        <div className="text-3xl mb-10 text-[#002998ef]">
          {language ? service?.titleUa : service?.titleEn}
        </div>
        <div className="grow">
          <div className="max-w-[1110px] mx-auto px-3 ">
            <img src={service.img} className="max-w-[299px] mx-auto rounded" />
            {description &&
              description.map((p, id) => (
                <p className="mt-6 text-left indent-5" key={id}>
                  {p}
                </p>
              ))}
            <div className="mt-8">
              <OpenPricesButton language={language} />
            </div>
            <div className="mt-8 mb-36">
              <PhoneButton>
                {language ? "Викликати майстра" : "Call a specialist"}
              </PhoneButton>
            </div>
          </div>
        </div>

        {/* <div>
          <Footer language={language} />
        </div> */}
      </div>
    </Fade>
  )
}

export default SingleService
